import { useEffect, useState } from 'react'

export const useDebouncedValue = <S>(value: S, debounceTime = 500) => {
  const [debouncedValue, setDebouncedValue] = useState(value)
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedValue(value)
    }, debounceTime)
    return () => clearTimeout(timeout)
  }, [debounceTime, value])

  return debouncedValue
}
